/* global window, document */

/**
 * Miscellaneous non-parallax scroll behaviors
 */
const scroll = ($) => {
  // Track scroll position to determine nav state
  const { body } = document;

  // Small nav
  const isPageTop = () => {
    if (window.scrollY > 50) {
      if (!body.classList.contains('small-nav')) {
        body.classList.add('small-nav');
      }
    } else if (window.scrollY === 0) {
      if (body.classList.contains('small-nav')) {
        body.classList.remove('small-nav');
      }
    }
  };
  window.addEventListener('scroll', isPageTop);

  // Pulse CTA button when entering viewport
  /* eslint-disable */
  $(window).on('resize scroll', function() {
    $('.paragraph--type-call-to-action').each(function() {
        var elementTop = $(this).offset().top;
        var elementBottom = elementTop + $(this).outerHeight();

        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();

        if (elementBottom > viewportTop && elementTop < viewportBottom) {
          $(this).delay(300).queue(function(){$(this).addClass('pulse')});
        }
      });
  });
  /* eslint-enable */
};

export default scroll;
